import styled from 'styled-components';

export const StarRating = styled.span`
  background-color: #18a160;
  border-radius: 2px;
  padding: 1px 3px;
  font-size: 12px;
  font-family: 'Rubik';
  font-weight: 700;
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: 34px;
  height: 15px;
  margin-left: 4px;
`;

export const StarContainer = styled.span`
  display: inline-flex;
  padding-top: 3px;
  align-items: flex-start;
  gap: 8px;
`;

export const StarImg = styled.img`
  height: 6px;
  width: 6px;
`;

export const Rating = styled.span`
  color: #FFF;
  text-align: right;
  font-family: 'Rubik';
  font-weight: 700;
  font-size: 12px;
  width: 17px;
  height: 14px;
`;
